import React from 'react';

import { Redirect, Switch } from 'react-router-dom';
import { Route } from '@modernhealth/web-analytics';

import { PaymentsSessionReviewPage } from './pages/SessionReviewPage';

const baseUrl = '/payments';

export const PaymentsRoutes = () => (
    <Switch>
        <Route
            exact
            path={`${baseUrl}/session-review`}
            analytics={{ pageName: 'payments-session-review' }}
            component={PaymentsSessionReviewPage}
        />

        <Redirect to="/dashboard" />
    </Switch>
);
